import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    Item,
    Form,
    Checkbox,
    Modal,
} from 'semantic-ui-react';

import { Link } from 'react-router-dom';

import Exit from '../../../assets/svg/Exit.svg';
import renommer from '../../../assets/svg/renommer.svg';
import supprimer from '../../../assets/svg/supprimer.svg';

import RenameList from './RenameList';
import DeleteList from './DeleteList';

//import new redux
import { addPkuidlist } from '../../../redux/actions/AppAction'
import { addList } from '../../../redux/actions/ListAction'

import { Currencies } from '../../../constants/Currencies';
import { translate } from "react-translate";

// API
import API from '../../../services/api';


const mapStateToProps = state => ({
    app: state.app,
    list: state.list
})

const mapActionToProps = {
    addPkuidlist: addPkuidlist,
    addList: addList,
}

class ConnectedListoComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fkuiduser: this.props.fkuiduser,
            listesArticles: [],
            fkuidlist: null,
            pkuidlist: null,
            fkuidarticle: null,
            fkuidstore: null,
            quantity: null,
            price: null,
            state: null,
            title: null,
            response: null,
            responsa: null,
            responso: null,
            error: null,
            name_article: null,
            q: null,
            importImg: null,
            modalOpenDelete: false,
            modalOpenRename: false,
            prixos: null,
            currency: null
        }

        this.setPkuidlist = this.setPkuidlist.bind(this);
        this.addList = this.addList.bind(this);
    }

    setPkuidlist(pkuidlist) {
        this.props.addPkuidlist(pkuidlist)
    }

    handleOpenRename = () => this.setState({
        modalOpenRename: true,
    })

    handleOpenDelete = () => this.setState({
        modalOpenDelete: true,
    })

    handleCloseRename = () => this.setState({
        modalOpenRename: false,

    },
        this.componentWillMount)

    handleCloseDelete = () => this.setState({
        modalOpenDelete: false,

    },
        this.componentWillMount)


    addList(list) {
        this.props.addList(list);
    }

    componentDidMount() {
        var self = this;
        var listData = {
            fkuiduser : this.props.app.id
        };
        API.getList(this.props.app.token, listData).then((res) => {
            var response = res.data;
            if(response.code == 401) {
                this.componentDidMount();
            }
            this.addList(response.lists);
            this.setState({
                response: true
            })
        }, (rej) => {
            this.setState({
                error: rej.error,
                response: false
            });
        });
        
        API.getUser(this.props.app.token).then((res) => {
            let tmpResponseCurrencies = Currencies.filter(currency => currency.value == res.data.currency);
            self.setState({
                currency: tmpResponseCurrencies.length > 0 ? tmpResponseCurrencies[0].text : '€',
            })
        });
    }

    handleClick(e, id) {
        e.preventDefault();
        this.setPkuidlist(id);
    }

    redirect(e, id) {
        e.preventDefault();
        if (e.target.nodeName !== "IMG") {
            window.location = "http://" + window.location.host + "#/listdetail/" + id;
        }

    }
    render() {
        const {t} = this.props;
        var centerText = {
            display:  'flex',
            flexDirection: 'column',
            justifyContent:  'center',
        }
        var showResultList = this.props.showResults ? this.props.showResults.lists : undefined;
        var lists = this.props.list ? this.props.list.list : undefined;
        return (
            <div>
                {	Object.entries( showResultList || lists || []).map((key, mainindex) => {
                        if (key[0] === 'code' || key[0] === 'msg') {
                        } else {
                            return (
                                <div>
                                  <Segment
                                    raised
                                    onClick={(e) => this.redirect(e, key[1].pkuidlist)}
                                    id="list-block"
                                    >



                                        <Grid>
                                            <Grid.Row columns={6}>
                                                <Grid.Column mobile={16} tablet={5} computer={5} style={centerText} className="list-block-row list-block-name">
                                                    <Header as='h4' style={{ color: 'rgb(114, 114, 114)' }}>{key[1].name}</Header>
                                                </Grid.Column>
                                                <Grid.Column mobile={8} tablet={2} computer={2} style={centerText} className="list-block-row">
                                                    <Header as='h4' style={{ color: 'rgb(114, 114, 114)' }}> {key[1].nb_article || 0} <span className="header-list-mobile">{' ' + t("HeaderCell2_title")}</span></Header>
                                                </Grid.Column>
                                                <Grid.Column mobile={8} tablet={2} computer={2} style={centerText} className="list-block-row">
                                                    <Header as='h4' style={{ color: 'rgb(114, 114, 114)' }}> {Number((key[1].quantite)).toFixed(2) || 0} <span className="header-list-mobile">{' ' + t("HeaderCell3_title")}</span></Header>
                                                </Grid.Column>
                                                <Grid.Column  mobile={16} tablet={3} computer={3} style={centerText} className="list-block-row list-block-price" >
                                                    <Header as='h4' style={{ color: 'rgb(9, 99, 192)' }}>{Number((key[1].prix).toFixed(2))}{' ' +  this.state.currency}</Header>
                                                </Grid.Column>
                                                <Grid.Column mobile={13} tablet={2} computer={2} style={centerText} className="list-block-img">
                                                    <RenameList fkuidlist={key[1].pkuidlist} nameList={key[1].name} />
                                                </Grid.Column>
                                                <Grid.Column mobile={3} tablet={2} computer={2} style={centerText} className="list-block-img">
                                                    <DeleteList fkuidlist={key[1].pkuidlist} />
                                                </Grid.Column>
                                            </Grid.Row>

                                        </Grid>
                                    </Segment>

                                </div>
                            )
                        }
                    }
                    )
                }
            </div>
        );
    }
}

const ListoComponent = connect(mapStateToProps, mapActionToProps)(ConnectedListoComponent);
export default translate("ListesComponent")(ListoComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/ListoComponent.js